import { render, staticRenderFns } from "./ZButton.vue?vue&type=template&id=b740d0fa&"
import script from "./ZButton.vue?vue&type=script&lang=js&"
export * from "./ZButton.vue?vue&type=script&lang=js&"
import style0 from "./ZButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports